import type { Job } from "providers/HostedScrapingProvider";
import { formatDate } from "components/hosted-scraping/ProjectFormatDate";
import Spinner from "components/Spinner";

export const FinishedAtCell = ({job, onProgressDetailsClicked}: {job: Job; onProgressDetailsClicked: () => void}) => {
  if (job.status === 'running' && (job.inProgressTasks > 0 || job.startedAt === undefined)) {
    return (<div className="flex flex-row">
      <Spinner className="w-5 h-5 mr-2 animate-spin" />
      <div onClick={onProgressDetailsClicked}><div className="cursor-pointer underline text-brandDarkest dark:text-primary-800 underline-offset-2">Progress details</div></div>
    </div>);
  } else {
    return <>{formatDate(job.finishedAt)}</>;
  }
}
